const UNSAFE_PATH_PATTERN = /(\.\.|\/|\\|%2f|%5c|%2e%2e)/i
const SAFE_ROUTE_PATTERN = /^[A-Za-z0-9._-]+$/

export const isUnsafePathValue = value => {
  const raw = String(value ?? '').trim()
  return raw !== '' && UNSAFE_PATH_PATTERN.test(raw)
}

export const toSafePathSegment = value => {
  const raw = String(value ?? '').trim()

  if (!raw) {
    return ''
  }

  if (isUnsafePathValue(raw)) {
    throw new Error(`Unsafe path segment: ${raw}`)
  }

  return encodeURIComponent(raw)
}

export const toSafeRouteParam = value => {
  const raw = String(value ?? '').trim()

  if (!raw || UNSAFE_PATH_PATTERN.test(raw) || !SAFE_ROUTE_PATTERN.test(raw)) {
    return ''
  }

  return encodeURIComponent(raw)
}

export const toSafeQueryString = queryParams => {
  if (!queryParams) {
    return ''
  }

  const source =
    typeof queryParams === 'string'
      ? queryParams.replace(/^[?&]+/, '')
      : Object.entries(queryParams).reduce((acc, [key, value]) => {
          if (value === undefined || value === null) {
            return acc
          }

          acc.append(String(key), String(value))
          return acc
        }, new URLSearchParams())

  const params = new URLSearchParams(typeof source === 'string' ? source : source.toString())

  for (const [key, value] of params.entries()) {
    if (!key || UNSAFE_PATH_PATTERN.test(key) || UNSAFE_PATH_PATTERN.test(value)) {
      throw new Error(`Unsafe query parameter: ${key || value}`)
    }
  }

  return params.toString()
}

export const sanitizeSearchQuery = searchQuery => {
  const raw = String(searchQuery ?? '').trim()

  if (!raw) {
    return ''
  }

  if (UNSAFE_PATH_PATTERN.test(raw)) {
    throw new Error(`Unsafe search query: ${raw}`)
  }

  return raw
}
